// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:33:50

export default {
  "id": "paws-and-pals-diner",
  "slug": "paws-and-pals-diner",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b1decdb4f2744352af9ca588a766b7a7-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b1decdb4f2744352af9ca588a766b7a7/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Paws & Pals Diner",
      "description": "Welcome to Paws & Pals Diner!\n\nStep into the paws of a diner manager and embark on a delightful 2D adventure where every customer and staff member is an adorable animal! In this charming and whimsical world, you'll manage a bustling diner filled with furry friends, unlock delicious foods, and attract a variety of cute customers.\n\nAre you ready to create the diner of your dreams and make every animal's visit a memorable one?\n\nJoin Paws & Pals Diner today!",
      "instructions": "use mouse (or tap) to interact with buttons and in game items.",
      "genres": [
        "Casual",
        "Cooking"
      ],
      "tags": [
        "cat",
        "food",
        "restaurant"
      ]
    },
    "zh-CN": {
      "title": "爪爪与伙伴餐厅",
      "description": "欢迎来到Paws & Pals餐厅！\n\n化身餐厅经理，踏上一段充满乐趣的2D冒险之旅，在这里，每一位顾客和员工都是可爱的小动物！在这个迷人而梦幻的世界里，你将经营一家熙熙攘攘的餐厅，提供美味的食物，并吸引各式各样的可爱顾客。\n\n你准备好创建梦想中的餐厅，让每一次动物的拜访都成为难忘的回忆了吗？\n\n加入Paws & Pals餐厅吧！",
      "instructions": "使用鼠标（或轻触）与按钮和游戏内物品交互。",
      "genres": [
        "休闲",
        "烹饪"
      ],
      "tags": [
        "猫",
        "食物",
        "餐厅"
      ]
    },
    "zh-TW": {
      "title": "爪與好友餐廳",
      "description": "歡迎來到爪爪與親朋餐廳！\n\n步入餐廳經理的腳步，踏上一次愉快的2D冒險，這裡的每位顧客和員工都是可愛的動物！在這個迷人而古靈精怪的世界裡，你將經營一間充滿毛茸茸朋友的人潮擁擠的餐廳，開啟美味的食物，並吸引各種可愛的顧客。\n\n你準備好創造夢想的餐廳，並讓每一隻動物的到訪都變得難忘嗎？\n\n今天加入爪爪與親朋餐廳吧！",
      "instructions": "使用滑鼠（或點擊）與按鈕及遊戲內物品互動。",
      "genres": [
        "休闲",
        "烹飪"
      ],
      "tags": [
        "貓",
        "食物",
        "餐廳"
      ]
    },
    "zh-HK": {
      "title": "爪與伴餐廳",
      "description": "歡迎來到「毛孩夥伴餐廳」！\n\n化身餐廳經營者，踏上一次愉快 的2D冒險之旅，每一位顧客和員工都是可愛的動物！在這個迷人而奇妙的世界裡，你將經營一間充滿毛茸茸朋友的繁忙餐廳，解鎖美味佳肴，並吸引各式各樣可愛的顧客。\n\n你準備好創造你夢想的餐廳，並讓每一隻動物的到訪都成為難忘的經歷了嗎？\n\n今 天就加入「毛孩夥伴餐廳」吧！",
      "instructions": "使用滑鼠（或觸控）與按鈕及遊戲內物品互動。",
      "genres": [
        "隨意",
        "烹饪"
      ],
      "tags": [
        "貓",
        "食物",
        "餐廳"
      ]
    },
    "ja": {
      "title": "パズズ＆パルズダイナー",
      "description": "パウズ＆パルズダイナーへようこそ！\n\nダイナーのマネージャーの足跡を踏み、魅力的で幻想的な2Dアドベンチャーに参加して、お客様やスタッフ全員が可愛い動物である世界で楽しい冒険に出かけましょう。この魅力的でユーモラスな世界で、毛むくじゃらの友達が満載のダイナーを管理し、美味しい料理を解禁し、様々な可愛いお客様を引き寄せましょう。\n\n夢のダイナーを作り、動物たちの訪問を一つ一つ思い出に残るものにする準備はできていますか？\n\nパウズ＆パルズダイナーに今すぐ参加して！",
      "instructions": "ボタンやゲーム内アイテムと対話するためにマウスを使用するか、タップしてください。",
      "genres": [
        "カジュアル",
        "料理"
      ],
      "tags": [
        "猫",
        "食事",
        "レストラン"
      ]
    },
    "ko": {
      "title": "발과 친구들 다이너",
      "description": "환영합니다, 파스 & 팔스 디너에!\n\n디너 매니저의 발을 걸어놓고, 모든 고객과 직원이 귀엽은 동물로 이뤄진 즐거운 2D 모험에 뛰어들어 보세요! 이 멋진 꿈결적인 세상에서, 당신은 거미줄을 치는 동물들로 가득 찬 디너를 운영하며, 맛있는 음식을 해금하고, 다양한 귀엽은 고객들을 유치할 수 있습니다.\n\n당신은 꿈의 디너를 만들고, 모든 동물의 방문을 기억에 남을 만하게 만들 준비가 되셨나요?\n\n파스 & 팔스 디너에 오세요!",
      "instructions": "마우스(또는 탭)를 사용하여 버튼과 게임 아이템과 상호작용하세요.",
      "genres": [
        "캐주얼",
        "요리"
      ],
      "tags": [
        "고양이",
        "음식",
        "레스토랑"
      ]
    },
    "fr": {
      "title": "Paws & Pals Diner\nDîner des Copains des Pattes",
      "description": "Bienvenue au Diner des Patounes et Copains !\n\nEngagez-vous dans la peau d'un gestionnaire de café et plongez dans une aventure délicieuse en 2D où chaque client et employé est un adorable animal ! Dans ce monde charmant et fantaisiste, vous gérerez un café animé rempli de petites bêtes, déverrouillerez des plats délicieux et attirerez une variété de clients mignons.\n\nPrêt à créer le café de vos rêves et à rendre chaque visite d'un animal mémorable ?\n\nRejoignez le Diner des Patounes et Copains aujourd'hui !",
      "instructions": "Utilisez la souris (ou appuyez) pour interagir avec les boutons et les éléments du jeu.",
      "genres": [
        "Facile",
        "Cuisine"
      ],
      "tags": [
        "chat",
        "nourriture",
        "restaurant"
      ]
    }
  }
};
